import { PresenceZone, PresenceZoneRequest } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdatePresenceZone(
  camId: string,
  zoneId: string,
  onSuccess?: (zone: PresenceZone) => void
) {
  const url = `/v2/orm/presence/zones/${zoneId}`;
  const request = new Request(url, { method: 'PATCH' });

  return useAuthenticatedMutation<PresenceZone, PresenceZoneRequest>(request, {
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    onSuccessInvalidationKeys: [
      ['presence-zones', camId],
      ['presence-latest', camId],
      ['presence-rules', camId],
    ],
    onSuccess,
  });
}

export default useUpdatePresenceZone;
